import React from 'react';
import { Navbar as BSNavbar, Container, Nav, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logoWhite from '../../assets/logo-white.svg';

const navbarStyle = {
  background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
  padding: '0.25rem 0',
  border: 'none',
};

const brandStyle = {
  fontFamily: "'Inter', sans-serif",
  fontWeight: 800,
  fontSize: '1.2rem',
  letterSpacing: '-0.02em',
  background: 'linear-gradient(135deg, #fff 0%, #e2e8f0 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

const pageLabels = {
  '/': 'Dashboard',
  '/roundrobin': 'Round-Robin',
  '/survey': 'Survey',
  '/admin': 'Admin Panel',
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const currentLabel = pageLabels[location.pathname] || '';

  return (
    <BSNavbar style={navbarStyle} variant="dark">
      <Container fluid className="px-3">
        <BSNavbar.Brand style={brandStyle} className="d-flex align-items-center">
          <img src={logoWhite} alt="TopCX" style={{ height: 90, marginRight: 14 }} />
          {currentLabel && (
            <span style={{ opacity: 0.7, fontWeight: 500, fontSize: '1rem' }}>
              {currentLabel}
            </span>
          )}
        </BSNavbar.Brand>
        <Nav className="ms-auto align-items-center">
          {user?.subdomain && (
            <span
              className="me-3"
              style={{
                color: '#818cf8',
                fontSize: '0.75rem',
                fontWeight: 600,
                background: 'rgba(99,102,241,0.15)',
                padding: '0.25rem 0.75rem',
                borderRadius: 8,
              }}
            >
              {user.subdomain}
            </span>
          )}
          <span
            className="me-3"
            style={{ color: '#94a3b8', fontSize: '0.8125rem', fontWeight: 500 }}
          >
            {user?.name || user?.email}
          </span>
          <Button
            variant="outline-light"
            size="sm"
            onClick={logout}
            style={{
              borderRadius: 8,
              fontWeight: 600,
              fontSize: '0.75rem',
              borderColor: 'rgba(255,255,255,0.3)',
            }}
          >
            Logout
          </Button>
        </Nav>
      </Container>
    </BSNavbar>
  );
}
